<template lang='slm'>
  tr :class='{ "active-song": playing || loading }' @click='playIfNotPlaying'
    td
      .number {{ index + 1 }}
      play-pause-circle.play-controls :scale='0.4' :playing='playing' :loading='loading' :progress='progress' @click.stop='playPauseClick' :draw-bg='false' color='white'
    td width='100%' {{ song.title }}
    td {{ song.duration | duration }}
</template>

<style lang='stylus' scoped>
  .number
  .play-controls
    text-align center
    width 35px
  .play-controls
    cursor pointer
    display none
  tr:not(.active-song) td
    cursor pointer
  tr:hover
  tr.active-song
    .number
      display none
    .play-controls
      display block
</style>

<script>
import PlayPauseCircle from '@/components/PlayPauseCircle';

export default {
  name: 'MusicTableRow',
  components: { PlayPauseCircle },
  props: {
    artist: {
      type: String,
    },
    song: {
      type: Object,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      playing: false,
      loading: false,
      progress: 0,
    };
  },
  methods: {
    playIfNotPlaying() {
      if (this.playing || this.loading) return;
      this.playPauseClick();
    },
    playPauseClick() {
      if (this.loading) return;
      if (this.playing) {
        this.$root.pauseAudio();
      } else {
        this.$root.playAudio({
          title: this.song.title,
          author: this.artist,
          fileId: this.song.fileId,
          duration: this.song.duration,
          startFromPersent: this.progress,
          eventsHandler: {
            setPlaying: (value) => {
              this.playing = value;
            },
            setLoading: (value) => {
              this.loading = value;
            },
            setProgressPersent: (value) => {
              this.progress = value;
            },
            audioEnded: () => {
              this.$emit('audioEnded');
            },
          },
        });
      }
    },
  },
};
</script>
